import React, { useEffect, useState } from "react";
import { getNotifications } from "../../services/notificationService";
import Loader from "../../components/Loader";
import NotificationCard from "../../components/NotificationCard";

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNotifications()
      .then(data => setNotifications(data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;

  return (
    <div>
      <h2>Notifications</h2>
      {notifications.map((n, i) => (
        <NotificationCard key={i} notification={n} />
      ))}
    </div>
  );
}

export default Notifications;
